/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2025-08-12T15:42:30.835
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listReportRentContractCard,
	listReportRentContractCardInit,
	listReportRentContractCardByAuthorizations,
	deleteReportRentContractCard
	
} from '@api/report/ReportRentContractCard';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listReportRentContractCard({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportRentContractCard(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportRentContractCardByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportRentContractCardByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportRentContractCardInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportRentContractCardInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteReportRentContractCard({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportRentContractCard({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
